/**
 * Попап
 */
export var POPUP_ZINDEX = 5000;
/*
 * Дропдаун
 */

export var DROPDOWN_ZINDEX = 100;
/**
 * Хинт
 */

export var HINT_ZINDEX = 500;
/**
 * Снэкбар
 */

export var SNACKBAR_ZINDEX = 10000;
/**
 * Тултип
 */

export var TOOLTIP_ZINDEX = 2000;
/**
 * Фиксированный оверлей
 */

export var FIXED_OVERLAY_ZINDEX = 1000;